import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-terms-of-service",
  templateUrl: "./terms-of-service.component.html",
  styleUrls: ["./terms-of-service.component.css"],
})
export class TermsOfServiceComponent {
  ngOnInit(): void {}

  constructor(private router: Router) {}

  navigateToHome() {
    this.router.navigate(["/home"]);
  }
}
